import exes from "../../executables";
import { parseCmd, successRes, errorRes } from "../../utils";

// microkernel
class SystemAPI {
  constructor(fileSystem, systemData, setSystemData, currentDirHash = "root") {
    this.fileSystem = fileSystem;
    this.systemData = systemData;
    this.setSystemData = setSystemData;
    this.path = ["root"];
    this.directory = fileSystem.getDirectory(currentDirHash);
  }

  changePath = (newPath) => {
    const path = newPath.slice();
    const dir = this.fileSystem.getDirByPath(path);
    if (!dir) {
      return errorRes("Directory not found");
    } else {
      this.path = newPath;
      this.directory = dir;
      return successRes();
    }
  };

  getPath = () => {
    return this.path.slice();
  };

  setPath = (path) => {
    this.path = path.slice();
  };

  getDirectory = () => {
    return this.directory;
  };

  setDirectory = (dir) => {
    this.directory = dir;
  };

  getFileSystem = () => {
    return this.fileSystem;
  };

  createPath = (newPath) => {
    const path = newPath.slice();
    const dirName = path.pop();
    const parentDir = this.fileSystem.getDirByPath(path);
    if (!parentDir) {
      return errorRes("Parent directory not found");
    } else {
      const dirHash = this.fileSystem.createNewDirectory(
        parentDir.getHash(),
        dirName
      );
      this.path = newPath;
      this.directory = this.fileSystem.getDirectory(dirHash);
      return successRes();
    }
  };

  executeCommand = (cmd) => {
    const segs = parseCmd(cmd);
    let exeName = segs.shift();
    let resLines = [];
    if (exeName in exes) {
      let exe = exes[exeName];
      const res = exe.exec(segs, this);
      if (res.error) {
        if (res.multi) {
          res.errMsg.map((msg) => resLines.push(`Error: ${msg}`));
        } else {
          resLines.push(`Error: ${res.errMsg}`);
        }
        return resLines;
      } else {
        if (res.multi) {
          res.msg.map((msg) => resLines.push(msg));
        } else {
          resLines.push(res.msg);
        }
        return resLines;
      }
    } else {
      resLines.push(`Error: Command '${exeName}' not found`);
      return resLines;
    }
  };
}

export default SystemAPI;
